import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { UserLock, Home, ArrowLeft, Mail } from 'lucide-react';
import { SiteFooter } from '@/components/common/SiteFooter';
import { getApiEndpoint } from '@/utils/ERPUtils';
import { logger } from '@/utils/logger';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  const [contactEmail, setContactEmail] = useState<string | null>(null);

  // Admin contact comes from My Company -> Email via the public branding
  // endpoint. No email set -> the Contact Admin link simply doesn't render.
  useEffect(() => {
    let mounted = true;
    axios
      .get(getApiEndpoint('GET_DEFAULT_BRANDING'))
      .then((res) => {
        if (!mounted) return;
        const email = res?.data?.message?.data?.contact_email;
        if (email) setContactEmail(email);
      })
      .catch((err) => {
        logger.error('Branding fetch failed:', err);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="dark min-h-screen flex flex-col bg-background text-foreground">
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card/40 p-8 sm:p-10 text-center">
          {/* icon panel + badge */}
          <div className="mx-auto max-w-[280px] rounded-xl bg-secondary/60 border border-border px-8 py-10 mb-8">
            <UserLock className="w-14 h-14 mx-auto text-primary" aria-hidden="true" />
            <span className="inline-block mt-6 px-4 py-1.5 rounded-full bg-destructive/15 text-destructive text-[11px] font-semibold uppercase tracking-[0.12em]">
              Error 403
            </span>
          </div>

          <h1 className="text-2xl font-semibold tracking-tight mb-4">Access Denied</h1>
          <p className="text-muted-foreground leading-relaxed mb-8">
            You don't have the necessary permissions to access this page. Please
            ensure you are logged into the correct account or contact your
            administrator.
          </p>

          <div className="flex flex-col gap-3">
            <Button onClick={handleGoBack} className="h-12 gap-2">
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </Button>
            <Button onClick={handleGoHome} variant="outline" className="h-12 gap-2">
              <Home className="w-4 h-4" />
              Go Home
            </Button>
          </div>

          {contactEmail && (
            <a
              href={`mailto:${contactEmail}`}
              className="inline-flex items-center gap-2 mt-7 text-sm text-primary hover:underline underline-offset-4"
            >
              <Mail className="w-4 h-4" />
              Contact Admin
            </a>
          )}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ForbiddenPage;
